//domain info
export const GET_SUBDOMAIN_INFO = "GET_SUBDOMAIN_INFO";
export const GET_SUBDOMAIN_INFO_OK = GET_SUBDOMAIN_INFO + "_OK";

//session
export const GET_SESSION = "GET_SESSION";
export const GET_SESSION_OK = GET_SESSION + "_OK";

export const CREATE_SESSION = "CREATE_SESSION";
export const CREATE_SESSION_OK = CREATE_SESSION + "_OK";

//ping

export const START_PING = 'START_PING';
export const STOP_PING = 'STOP_PING';

//general input update
export const UPDATE_INPUT = "UPDATE_INPUT";

//general move_tab action
export const MOVE_TAB = "MOVE_TAB";

//tab1
const BASE_TAB_1 = "TAB_1_";
export const TAB_1_AUTOFILL = BASE_TAB_1 + "AUTOFILL";
export const TAB_1_AUTOFILL_SELECTED = TAB_1_AUTOFILL + "_SELECTED";

//Tab3
//A
const BASE_TAB_3A = "TAB_3A_";
export const TAB_3A_UPDATE_SELECTED_COUNTRIES =
  BASE_TAB_3A + "UPDATE_SELECTED_COUNTRIES";
//B
const BASE_TAB_3B = "TAB_3B_";
export const TAB_3B_TRIGGER_HELP_BLOCK = BASE_TAB_3B + "TRIGGER_HELP_BLOCK";
export const TAB_3B_RESET_HELP_BLOCK = BASE_TAB_3B + "RESET_HELP_BLOCK";
export const TAB_3B_UPDATE_INVOICE = BASE_TAB_3B + "UPDATE_INVOICE";

//Tab4
//A
const BASE_TAB_4A = "TAB_4A_";
export const TAB_4A_TOGGLE_YEAR = BASE_TAB_4A + "TOGGLE_YEAR";
//B
const BASE_TAB_4B = "TAB_4B_";
export const TAB_4B_TRIGGER_HELP_BLOCK = BASE_TAB_4B + "TRIGGER_HELP_BLOCK";
export const TAB_4B_RESET_HELP_BLOCK = BASE_TAB_4B + "RESET_HELP_BLOCK";
export const TAB_4B_UPDATE_INVOICE = BASE_TAB_4B + "UPDATE_INVOICE";

//Tab5
//A
const BASE_TAB_5A = "TAB_5A_";
export const TAB_5A_ADD_CUSTOMER = BASE_TAB_5A + "ADD_CUSTOMER";
export const TAB_5A_ADD_CUSTOMER_AUTOFILL = TAB_5A_ADD_CUSTOMER + "_AUTOFILL";
export const TAB_5A_DELETE_CUSTOMER = BASE_TAB_5A + "DELETE_CUSTOMER";

const BASE_TAB_5B = "TAB_5B_";
export const TAB_5B_INVOICE_AUTOFILL = BASE_TAB_5B + "INVOICE_AUTOFILL";
export const TAB_5B_INVOICE_AUTOFILL_RESET_LOADER =
  TAB_5B_INVOICE_AUTOFILL + "_RESET_LOADER";
export const TAB_5B_INVOICE_AUTOFILL_SELECTED =
  TAB_5B_INVOICE_AUTOFILL + "_SELECTED";
export const TAB_5B_UPDATE_INVOICE = BASE_TAB_5B + "UPDATE_INVOICE";

//tab6
const BASE_TAB_6 = "TAB_6";
export const TAB_6_REQUEST_PRICE_OK = BASE_TAB_6 + "_REQUEST_PRICE_OK";

//companySearch
const BASE_COMPANY_SEARCH = "COMPANY_SEARCH_";
export const COMPANY_SEARCH_LOAD = BASE_COMPANY_SEARCH + "LOAD";
export const COMPANY_SEARCH_LOAD_OK = COMPANY_SEARCH_LOAD + "_OK";

export const COMPANY_SEARCH_RESET = BASE_COMPANY_SEARCH + "RESET";
export const COMPANY_SEARCH_HIDE = BASE_COMPANY_SEARCH + "HIDE";
export const COMPANY_SEARCH_RESET_RESULTS =
  BASE_COMPANY_SEARCH + "RESET_RESULTS";

export const COMPANY_SEARCH_SELECTED = "COMPANY_SEARCH_SELECTED";

export const SINGLE_INVOICE_AUTOFILL = "SINGLE_INVOICE_AUTOFILL";
export const SINGLE_INVOICE_AUTOFILL_RESET = "SINGLE_INVOICE_AUTOFILL_RESET";
export const SINGLE_INVOICE_PRICE_OK = "SINGLE_INVOICE_PRICE_OK";
export const SINGLE_INVOICE_PRICE_RESET = "SINGLE_INVOICE_PRICE_RESET";

export const NEXT_STEP_BTN_START_LOADING = "NEXT_STEP_BTN_START_LOADING";
export const NEXT_STEP_BTN_FINISH_LOADING = "NEXT_STEP_BTN_FINISH_LOADING";
